import React from 'react';
import { TooltipBouncer, TooltipBouncerProps } from '../TooltipBouncer';
import petInsurerBouncerImg from '../../assets/pet-insurer-bouncer.png';
import closeBouncerImg from '../../assets/close-bouncer.png';
import { theme } from '../../../../themes/base-theme';
export type PetInsurerBouncerProps = Partial<TooltipBouncerProps> & {
  isOpen?: boolean;
};
export const PetInsurerBouncer = ({
  isOpen,
  onClick,
  avatar,
  tooltip,
  ...rest
}: PetInsurerBouncerProps) => <TooltipBouncer avatar={{
  src: isOpen ? closeBouncerImg : petInsurerBouncerImg,
  alt: 'Need pet insurance?',
  ...avatar,
  containerProps: {
    border: 'none',
    height: '104px',
    width: '104px',
    cursor: 'pointer',
    borderRadius: 'unset',
    justifyContent: 'end',
    // Cannot use optional chaining due to wagcontent
    ...(avatar && avatar.containerProps && {
      ...avatar.containerProps
    })
  },
  imageProps: {
    alt: 'Need pet insurance?',
    borderRadius: 'unset',
    // Cannot use optional chaining due to wagcontent
    ...(avatar && avatar.imageProps && {
      ...avatar.imageProps
    }),
    style: {
      cursor: 'pointer',
      // Cannot use optional chaining due to wagcontent
      ...(avatar && avatar.imageProps && avatar.imageProps.style && {
        ...avatar.imageProps.style
      })
    }
  }
}} tooltip={{
  text: 'Need pet insurance?',
  show: true,
  width: 'max-content',
  px: '16px',
  py: '16px',
  marginLeft: '-11px',
  fontSize: ['16px', '24px'],
  borderWidth: '8px',
  backgroundColor: theme.colors.mySin,
  tooltipColor: theme.colors.mySin,
  ...tooltip,
  style: {
    opacity: !isOpen ? 1 : 0,
    transition: 'opacity .2s ease-in-out',
    // Cannot use optional chaining due to wagcontent
    ...(tooltip && tooltip.style && {
      ...tooltip.style
    })
  }
}} zIndex={1000} height="88px" width={['100%', isOpen ? '600px' : '0px']} top="16px" position="relative" onClick={onClick} {...rest} data-sentry-element="TooltipBouncer" data-sentry-component="PetInsurerBouncer" data-sentry-source-file="PetInsurerBouncer.tsx" />;